import React, { type RefObject, useRef } from "react";
import { FocusTrap } from "focus-trap-react";
import * as CompareItemStyles from "../styles/CompareItem";
import * as SelectPaneStyles from "../../../../../common-deprecated/styles/v2/toyota/custom/SelectPane";
import * as Button from "../../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as Text from "../../../../../common-deprecated/styles/v2/toyota/utilities/Text";
import { Backdrop } from "../../../../../common-deprecated/styles/v2/toyota/components/Backdrop";
import { useCloseOnOutsideClick } from "../../../../../common-deprecated/hooks";
import { useCompareV2Selector } from "../../../redux/store";
import ModelPanel from "./ModelPanel";
import GradePanel from "./GradePanel";
import { CompareV2Label } from "../../../utils/labels";
import { getEngineName } from "../../../utils/formatters/nameFormatters";
import { emptySelectedCarIds } from "../../../utils/constants";
import useSelectGrade from "../../../hooks/useSelectGrade";
import ConfigurationPanel from "./ConfigurationPanel";
import { NcCompareContext } from "../../../../../common-deprecated/types/NewCarCompareTypes";

export type SelectGradePropsType = {
    title: string;
    subtitle?: string;
    index: number;
    opened?: boolean;
    setOpenState: (open: boolean) => void;
    compareHeaderRef: RefObject<HTMLElement | null>;
    placeholder?: boolean;
};

const SelectGrade = (props: SelectGradePropsType): JSX.Element => {
    const { title, subtitle, index, opened, setOpenState, compareHeaderRef, placeholder } = props;
    const isLeasing = useCompareV2Selector(
        (state) => state.newCarCompare.ncCompareContext === NcCompareContext.Leasing,
    );
    const selectedEngines = useCompareV2Selector((state) => state.newCarCompare.selectedEngines);
    const { selectedCar, setSelectedCar, makeSelection, closeFunction, compareHeaderHeight, viewPortHeight } =
        useSelectGrade(index, opened, setOpenState, compareHeaderRef);

    const paneRef = useRef<HTMLElement>(null);
    useCloseOnOutsideClick(paneRef, closeFunction);

    return (
        <>
            <>
                <CompareItemStyles.Title>
                    {title === "compareBodyTopSelectCar" ? <CompareV2Label label="compareBodyTopSelectCar" /> : title}
                </CompareItemStyles.Title>
                {!placeholder && (
                    <>
                        <CompareItemStyles.Subtitle>{subtitle}</CompareItemStyles.Subtitle>
                        <CompareItemStyles.EngineNameTitle>
                            {getEngineName(selectedEngines[index])}
                        </CompareItemStyles.EngineNameTitle>
                    </>
                )}
            </>

            {opened && (
                <>
                    <FocusTrap>
                        <SelectPaneStyles.Wrapper
                            ref={paneRef}
                            top={compareHeaderHeight}
                            height={viewPortHeight && compareHeaderHeight ? viewPortHeight - compareHeaderHeight : null}
                            id="select-compare-modal-grade-pane"
                        >
                            <SelectPaneStyles.Body>
                                <SelectPaneStyles.Panels
                                    currentPanel={selectedCar.model ? 1 : 0}
                                    panelCount={2}
                                    compareHeaderHeight={compareHeaderHeight}
                                    height={viewPortHeight}
                                >
                                    <ModelPanel
                                        setModel={(model) => setSelectedCar({ ...selectedCar, model, gradeId: "" })}
                                        selectedCar={selectedCar}
                                    />
                                    {isLeasing ? (
                                        <ConfigurationPanel
                                            setSelectedCar={setSelectedCar}
                                            selectedCar={selectedCar}
                                            clearSelection={() => setSelectedCar({ ...emptySelectedCarIds })}
                                        />
                                    ) : (
                                        <GradePanel
                                            setSelectedCar={setSelectedCar}
                                            selectedCar={selectedCar}
                                            clearSelection={() => setSelectedCar({ ...emptySelectedCarIds })}
                                        />
                                    )}
                                </SelectPaneStyles.Panels>
                            </SelectPaneStyles.Body>

                            <SelectPaneStyles.Footer>
                                <Button.Primary disabled={!selectedCar.gradeId} onClick={makeSelection}>
                                    <Text.Button>
                                        <CompareV2Label label="compareSelectGradeConfirm" />
                                    </Text.Button>
                                </Button.Primary>
                                <Button.Outline onClick={closeFunction}>
                                    <Text.Button>
                                        <CompareV2Label label="compareSelectGradeCancel" />
                                    </Text.Button>
                                </Button.Outline>
                            </SelectPaneStyles.Footer>
                        </SelectPaneStyles.Wrapper>
                    </FocusTrap>
                    <Backdrop />
                </>
            )}
        </>
    );
};

export default SelectGrade;
